import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss']
})
export class PartnerComponent implements OnInit {
  public siteKey = environment.reCatchSiteKey;
  // @ViewChild('captchaElem') captchaElem;
  public feedbackForm;
  public isSubmitted = false;
  public isError = false;
  public feedSuccess = '';
  public feedError = '';
  constructor(private _api: ApiService) { }

  ngOnInit() {
    this.createForm();
  }
  private createForm() {
    this.feedbackForm = new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3)])),
      email: new FormControl('', Validators.compose([Validators.required, Validators.email])),
      mobile: new FormControl('', Validators.compose([Validators.required, Validators.minLength(10), Validators.minLength(10)])),
      city: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3)])),
      recaptcha: new FormControl('', Validators.compose([Validators.required]))
    });
  }
  get formControls() { return this.feedbackForm.controls; }
  becomePartner() {
    console.log(this.feedbackForm.valid, this.feedbackForm.value);
    this.isSubmitted = true;
    this.feedSuccess = '';
    this.feedError = '';
    if (this.feedbackForm.invalid) {
      return;
    }
    console.log(this.feedbackForm.valid, this.feedbackForm.value);
    if (this.feedbackForm.valid) {
      console.log('submit');
      this._api.becomeAPartner(this.feedbackForm.value).subscribe((response) => {
        console.log(response);
        this.isSubmitted = false;
        this.feedbackForm.reset();
        if (response.responseType === 'success') {
          this.feedError = '';
          this.feedSuccess = 'Thank you for your interest! We will contact you soon.';
        } else {
          this.feedSuccess = '';
          this.feedError = 'Error occured while sending email. Please try again later.';
        }
      }, (err) => {
        console.log('error', err);
        this.feedSuccess = '';
        this.feedError = 'Error occured while sending email. Please try again later.';
      });
    }
  }

  handleSuccess(e) {
    console.log('reCaptcha Response', e);
  }
  handleLoad() {
    console.log('reCaptcha Loaded');
  }

  handleReset() {
    console.log('reCaptcha Reset');
  }

  handleExpire() {
    console.log('reCaptcha Expired');
  }
}
